import Provider from './provider'

export const wrapRootElement = Provider
